import React, { useMemo } from "react";
import Layout from "../../providers/Layout";
import { ArticleListBreadcrumbs } from "../../components/Breadcrumbs/Breadcrumbs";
import BoxLegalAdvice from "../../components/BoxLegalAdvice/BoxLegalAdvice";
import BoxBuySubscription from "../../components/BoxBuySubscription/BoxBuySubscription";
import BoxNewsletter from "../../components/BoxNewsletter/BoxNewsletter";
import { getLayoutProps } from "../../services/serverSideRequests";
import {
  Page,
  MainContent,
  Aside,
  PageHeader,
  device,
} from "../../services/styles";
import { AlphabetLetters } from "../../partials/autorzy/AlphabetLetters";
import queryString from "query-string";
import { getJournalists } from "../../services/requests";
import { AuthorCard } from "../../partials/autorzy/AuthorCard";
import { Grid, Space } from "../../styled/Styled.sc";
import styled from "styled-components";
import { useRouter } from "next/router";

const S = {
  MainContent: styled(MainContent)`
    @media ${device.desktop} {
      margin-right: 20px;
    }
  `,
  Grid: styled(Grid)`
    > * {
      max-width: 270px;
      margin-left: auto;
      margin-right: auto;
    }
  `,
};
const Autorzy = ({ layoutProps, journalists }) => {
  const router = useRouter();
  const search = router.query.search;

  function getName(journalist) {
    const titles = ["dr", "prof."];
    const nameParts = journalist.name
      .split(" ")
      .filter((namePart) => !titles.includes(namePart)); // separate names and cut off title
    const names = nameParts.slice(1); // cut off first name
    return names; // if journalist has more than one last name, we take first one and ignore the rest.
  }

  function getAvailableLetters() {
    function getFirstLetterOfLastName(journalist) {
      return getName(journalist)[0];
    }
    return [...new Set(journalists.map(getFirstLetterOfLastName))].sort();
  }

  function letterFilter(journalist) {
    if (!search) return true; // if there is no letter to filter for
    const name = getName(journalist);
    return name[0] === search;
  }

  const availableLetters = useMemo(getAvailableLetters, []);
  return (
    <Layout
      navbarLinks={layoutProps.navbarLinks}
      paths={layoutProps.paths}
      submenuLists={layoutProps.submenuLists}
      mainCategories={layoutProps.mainCategories}
      importantArticles={layoutProps.importantArticles}
      metatagsData={{ title: "Autorzy - portal agrarlex.pl" }}
    >
      <Page>
        <Aside>
          <BoxLegalAdvice />
          <BoxBuySubscription />
          <BoxNewsletter />
        </Aside>
        <S.MainContent>
          <ArticleListBreadcrumbs article={"Autorzy"} />
          <PageHeader>Autorzy</PageHeader>
          <Space x={10} />
          <AlphabetLetters availableLetters={availableLetters} />
          <Space y={40} />
          <S.Grid
            templateColumns="1fr"
            mdTemplateColumns="1fr 1fr"
            lgTemplateColumns="1fr 1fr 1fr"
            columnGap="50px"
            lgColumnGap="100px"
            rowGap="50px"
            alignItems="stretch"
          >
            {journalists.filter(letterFilter).map((journalist) => (
              <AuthorCard author={journalist} key={journalist.pk} />
            ))}
          </S.Grid>
          <Space y={40} />
          <AlphabetLetters availableLetters={availableLetters} />
        </S.MainContent>
      </Page>
    </Layout>
  );
};

export async function getServerSideProps() {
  const layoutPromise = getLayoutProps();
  const journalistsPromise = getJournalists(
    "?" + queryString.stringify({ site: 12, limit: 999 })
  );
  const layoutProps = await layoutPromise;
  const [journalists] = await journalistsPromise;
  return {
    props: {
      layoutProps,
      journalists: journalists.results,
    },
  };
}

export default Autorzy;
